export default "__VITE_ASSET__hD46EQRz__"